import React from 'react'
import { useStyles } from './styles.js'

const Upload = () => {
  const classes = useStyles()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="45"
      viewBox="0 0 36 36"
    >
      {/* <defs><style>.a{fill:none;}.b{fill:#f37320;fill-rule:evenodd;}</style></defs> */}
      <g transform="translate(0 0.042)">
        <rect
          class="a"
          fill="none"
          width="36"
          height="36"
          transform="translate(0 -0.042)"
        />
        <g transform="translate(11.026 11.556)">
          <path
            class="b"
            fill="#F37320"
            fillRule="evenodd"
            d="M201.906,616.214l3.252,3.252,2.283-2.283L200.258,610l-2.283,2.283.035.035-4.866,4.865,2.283,2.283,3.252-3.252V626.3h3.229Z"
            transform="translate(-193.143 -610)"
          />
        </g>
        <g transform="translate(6.875 6.874)">
          <path
            class="b"
            fill="#F37320"
            fillRule="evenodd"
            d="M188,631v4.036h2.422v-1.614h17.758v1.614H210.6V631Z"
            transform="translate(-188 -631)"
          />
        </g>
      </g>
    </svg>
  )
}
export default Upload
